const GoogleMaps = (($) => {
  /**
   * ------------------------------------------------------------------------
   * Class Definition
   * ------------------------------------------------------------------------
   */

  class GoogleMaps {
    constructor(element, config) {
      this._element = element;
      this._map = null;
      this._markers = [];
      this._infoWindow = null;
      this._listeners = [];
    }

    // Getters

    static get VERSION() {
      return VERSION;
    }

    show(callback) {
      if (this._element) {
        GoogleMaps.load(() => {
          this._renderMap();
          if (callback) {
            callback(this._map);
          }
        });
      }
    }

    resize() {
      if (this._map) {
        google.maps.event.trigger(this._map, "resize");
      }
    }

    addMarker(lat, lng, title) {
      const marker = new google.maps.Marker({
        position: { lat: parseFloat(lat), lng: parseFloat(lng) },
        map: this._map,
        title: title || null,
      });

      this._markers.push(marker);

      return marker;
    }

    openInfoWindowOnMarker(contentContainer, marker) {
      if (!this._infoWindow) {
        this._infoWindow = new google.maps.InfoWindow();
      }

      this._infoWindow.setContent(contentContainer);
      this._infoWindow.open(this._map, marker);
    }

    onBoundsChange(callback) {
      if (this._map) {
        this._map.addListener("bounds_changed", (e) => {
          callback(e);
        });
      }
    }

    onIdle(callback) {
      if (this._map) {
        this._map.addListener("idle", (e) => {
          callback(e);
        });
      }
    }

    clearMarkers() {
      this._markers.forEach(function (marker) {
        marker.setMap(null);
      });

      this._markers = [];
    }

    getMapInfo() {
      if (!this._map) {
        return;
      }

      const bounds = this._map.getBounds();
      const neBoundary = bounds.getNorthEast();
      const swBoundary = bounds.getSouthWest();
      const center = this._map.getCenter();
      const zoom = this._map.getZoom();

      return {
        minLat: swBoundary.lat(),
        maxLat: neBoundary.lat(),
        minLon: swBoundary.lng(),
        maxLon: neBoundary.lng(),
        centerLat: center.lat(),
        centerLng: center.lng(),
        zoom: zoom,
        cache: false,
      };
    }

    // Private
    _renderMap() {
      let $element = $(this._element);
      let defaultLat = $element.data("defaultLat") || -34.397;
      let defaultLng = $element.data("defaultLng") || 150.644;

      let lat = parseFloat($element.data("lat") || defaultLat);
      let lng = parseFloat($element.data("lng") || defaultLng);
      let zoom = parseInt($element.data("zoom") || 8);

      this._map = new google.maps.Map(this._element, {
        center: { lat: lat, lng: lng },
        zoom: zoom,
        scrollwheel: false,
        zoomControl: true,
        mapTypeControl: false,
        streetViewControl: false,
      });
    }

    // Dynamically injects the Maps JS API script the first time it's needed.
    // Subsequent calls queue onto the same load event rather than re-injecting.
    static load(callback) {
      if (GoogleMaps._ready) {
        callback();
        return;
      }

      GoogleMaps._queue = GoogleMaps._queue || [];
      GoogleMaps._queue.push(callback);

      if (GoogleMaps._loading) {
        return;
      }

      if (window.google && window.google.maps) {
        GoogleMaps._ready = true;
        GoogleMaps._flush();
        return;
      }

      GoogleMaps._loading = true;

      const key =
        (window.GOOGLE_MAPS_KEY) ||
        "AIzaSyA8tCoCM7Ful1hDTRbdv-WyHEr85dmLTCY";

      window._nhInitMap = function () {
        GoogleMaps._ready = true;
        GoogleMaps._loading = false;
        GoogleMaps._flush();
      };

      const tag = document.createElement("script");
      tag.src =
        "https://maps.googleapis.com/maps/api/js?key=" +
        key +
        "&callback=_nhInitMap";
      tag.async = true;
      document.body.appendChild(tag);
    }

    static _flush() {
      const queue = GoogleMaps._queue || [];
      GoogleMaps._queue = [];
      queue.forEach(function (cb) {
        cb();
      });
    }
  }

  return GoogleMaps;
})($);

export default GoogleMaps;
